import type { SVGProps } from 'react';
export type IconName = 'search' | 'heart' | 'download' | 'grid' | 'list' | 'arrow' | 'menu' | 'close' | 'check' | 'mail' | 'sparkle' | 'filter';
const paths: Record<IconName, string> = {
  search: 'm21 21-4.5-4.5 M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0',
  heart: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z',
  download: 'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',
  grid: 'M3 3h6v6H3zM15 3h6v6h-6zM3 15h6v6H3zM15 15h6v6h-6z',
  list: 'M9 5h12M9 12h12M9 19h12M3 5h1M3 12h1M3 19h1',
  arrow: 'M5 12h14m-6-6 6 6-6 6', menu: 'M3 6h18M3 12h18M3 18h18', close: 'm6 6 12 12M6 18 18 6',
  check: 'm6 12 4 4 8-8M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
  mail: 'M3 5h18v14H3zM3 5l9 7 9-7', sparkle: 'm12 2 2.5 7.5L22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5Z',
  filter: 'M22 3H2l8 9.46V19l4 2v-8.54L22 3Z',
};
export default function StoreIcon({ name, ...props }: SVGProps<SVGSVGElement> & { name: IconName }) {
  return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}><path d={paths[name]} /></svg>;
}
export function PicelMark() {
  return <svg width="34" height="38" viewBox="0 0 24 26" fill="none" aria-hidden="true"><path d="m12 2 9 5v12l-9 5-9-5V7Z" stroke="currentColor" strokeWidth="2.5"/><path d="m12 8 4 2.5v5L12 18l-4-2.5v-5Z" fill="currentColor"/></svg>;
}
